(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.callbackReady === 'true') return;
    root.dataset.callbackReady = 'true';

    var trigger = root.querySelector('[data-callback-open]');
    var overlay = root.querySelector('[data-callback-overlay]');
    var dialog = root.querySelector('.wpc-callback__dialog');
    var closeButton = root.querySelector('[data-callback-close]');
    var form = root.querySelector('form.wpc-callback__form');
    var formView = root.querySelector('[data-callback-form-view]');
    var successView = root.querySelector('[data-callback-success-view]');
    var phone = root.querySelector('[data-callback-phone]');
    var name = root.querySelector('[data-callback-name]');
    var message = root.querySelector('[data-callback-message]');
    var order = root.querySelector('[data-callback-order]');
    var quantitySection = root.querySelector('[data-callback-quantity-section]');
    var quantity = root.querySelector('[data-callback-quantity]');
    var quantityError = root.querySelector('[data-callback-quantity-error]');
    var productPrice = root.querySelector('[data-callback-product-price]');
    var productPart = root.querySelector('[data-callback-product-part]');
    var productImage = root.querySelector('[data-callback-product-image]');
    var productRoot = root.closest('[data-wp-amazon-product]');
    var body = root.querySelector('[data-callback-body]');
    var error = root.querySelector('[data-callback-phone-error]');
    var serverError = root.querySelector('[data-callback-server-error]');
    var fallbackError = root.querySelector('[data-callback-fallback-error]');
    var activeKey = 'wpc_contact_active_form_v1';
    var pendingKey = 'wpc_callback_pending_' + root.dataset.callbackSectionId;
    var draftKey = 'wpc_callback_draft_' + root.dataset.callbackSectionId;
    var activeValue = 'callback:' + root.dataset.callbackSectionId;
    var productUrl = root.dataset.callbackProductUrl || window.location.href;
    var productTitle = root.dataset.callbackProductTitle || '';
    var fallbackPart = root.dataset.callbackPart || '';
    var fixedPart = root.dataset.callbackFixedPart || '';
    var initialPrice = root.dataset.callbackInitialPrice || '';
    var initialVariantId = root.dataset.callbackInitialVariant || '';
    var initialVariantSku = root.dataset.callbackInitialSku || '';
    var selectedProduct = { url: productUrl, variant: String(initialVariantId), part: String(fallbackPart || ''), sku: String(initialVariantSku || ''), price: initialPrice };
    var previousOverflow = null;

    function storageGet(key) {
      try { return sessionStorage.getItem(key); } catch (err) { return null; }
    }
    function storageSet(key, value) {
      try { sessionStorage.setItem(key, String(value)); } catch (err) {}
    }
    function storageRemove(key) {
      try { sessionStorage.removeItem(key); } catch (err) {}
    }
    function saveDraft() {
      storageSet(draftKey, JSON.stringify({ savedAt: Date.now(), phone: phone.value, name: name.value, message: message.value, order: order.checked, quantity: quantity.value }));
    }
    function restoreDraft() {
      var data = storageGet(draftKey);
      storageRemove(draftKey);
      if (!data) return;
      try {
        var draft = JSON.parse(data);
        if (!draft || Date.now() - draft.savedAt > 15 * 60 * 1000) return;
        phone.value = draft.phone || '';
        name.value = draft.name || '';
        message.value = draft.message || '';
        order.checked = !!draft.order;
        quantity.value = String(draft.quantity || 1);
        syncOrdering();
      } catch (err) {}
    }
    function cleanQuantity(value) {
      var n = Number(value);
      if (!Number.isInteger(n) || n < 1 || n > 9999) return null;
      return n;
    }
    function syncOrdering() {
      quantitySection.hidden = !order.checked;
      quantityError.hidden = true;
      quantity.removeAttribute('aria-invalid');
    }
    function syncProduct() {
      selectedProduct = {
        url: productUrl,
        variant: String(initialVariantId),
        part: String(fallbackPart || ''),
        sku: String(initialVariantSku || ''),
        price: initialPrice
      };
      if (productRoot) {
        var variantSelect = productRoot.querySelector('[data-wp-variant-select]');
        var variantInput = productRoot.querySelector('[data-wp-variant-input]');
        var selected = variantSelect && variantSelect.selectedOptions[0];
        var id = selected ? selected.value : (variantInput ? variantInput.value : selectedProduct.variant);
        if (id) selectedProduct.variant = String(id);
        if (selected) {
          selectedProduct.sku = selected.dataset.sku || '';
          selectedProduct.part = String(fixedPart || selectedProduct.sku || '');
          selectedProduct.price = selected.dataset.price || selectedProduct.price;
        } else {
          var displayedPrice = productRoot.querySelector('[data-wp-price]');
          if (displayedPrice && displayedPrice.textContent.trim()) selectedProduct.price = displayedPrice.textContent.trim();
        }
        if (productPart) {
          productPart.textContent = selectedProduct.part
            ? 'Part #: ' + selectedProduct.part
            : (selectedProduct.sku ? 'SKU: ' + selectedProduct.sku : '');
        }
        var sourceImage = productRoot.querySelector('[data-wp-main-image]');
        if (sourceImage && productImage && sourceImage.getAttribute('src')) {
          productImage.src = sourceImage.currentSrc || sourceImage.src;
          productImage.alt = sourceImage.alt || productTitle;
        }
      }
      if (productPrice) productPrice.textContent = selectedProduct.price;
      try {
        var url = new URL(productUrl);
        if (selectedProduct.variant) url.searchParams.set('variant', selectedProduct.variant);
        selectedProduct.url = url.href;
      } catch (err) { /* Keep the canonical product URL. */ }
    }

    function tidyUrl() {
      try {
        var url = new URL(window.location.href);
        var changed = false;
        if (url.searchParams.get('contact_posted') === 'true') {
          url.searchParams.delete('contact_posted');
          changed = true;
        }
        if (/^#(?:wpc-callback-form|contact_form)/i.test(url.hash)) {
          url.hash = '';
          changed = true;
        }
        if (changed) window.history.replaceState(window.history.state, '', url.href);
      } catch (err) {}
    }
    function open(success) {
      if (overlay.parentNode !== document.body) document.body.appendChild(overlay);
      formView.hidden = !!success;
      successView.hidden = !success;
      if (previousOverflow === null) {
        previousOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
      }
      overlay.hidden = false;
      dialog.setAttribute('aria-labelledby', success ? successView.querySelector('.wpc-callback__title').id : formView.querySelector('.wpc-callback__title').id);
      dialog.setAttribute('aria-describedby', success ? successView.querySelector('.wpc-callback__subtitle').id : formView.querySelector('.wpc-callback__subtitle').id);
      if (success) successView.focus();
      else phone.focus();
    }
    function close(restoreFocus) {
      overlay.hidden = true;
      if (previousOverflow !== null) {
        document.body.style.overflow = previousOverflow;
        previousOverflow = null;
      }
      if (restoreFocus !== false && trigger.isConnected) trigger.focus();
    }

    trigger.addEventListener('click', function () {
      syncProduct();
      var mainQty = productRoot && productRoot.querySelector('[data-wp-qty-input]');
      quantity.value = String(cleanQuantity(mainQty && mainQty.value) || 1);
      syncOrdering();
      open(false);
    });
    closeButton.addEventListener('click', function () { close(true); });
    overlay.addEventListener('click', function (event) {
      if (event.target === overlay) close(true);
    });
    overlay.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        close(true);
        return;
      }
      if (event.key !== 'Tab') return;
      var focusable = Array.from(dialog.querySelectorAll('button, input:not([type="hidden"]), textarea:not([hidden])')).filter(function (node) {
        return !node.disabled && !node.closest('[hidden]') && node.getClientRects().length > 0;
      });
      if (!focusable.length) { event.preventDefault(); dialog.focus(); return; }
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (!focusable.includes(document.activeElement)) {
        event.preventDefault();
        (event.shiftKey ? last : first).focus();
      } else if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    order.addEventListener('change', syncOrdering);
    quantity.addEventListener('input', function () {
      quantityError.hidden = true;
      quantity.removeAttribute('aria-invalid');
    });
    root.querySelector('[data-callback-qty-minus]').addEventListener('click', function () {
      quantity.value = String(Math.max(1, (cleanQuantity(quantity.value) || 1) - 1));
    });
    root.querySelector('[data-callback-qty-plus]').addEventListener('click', function () {
      quantity.value = String(Math.min(9999, (cleanQuantity(quantity.value) || 1) + 1));
    });
    if (productRoot) {
      var mainVariantSelect = productRoot.querySelector('[data-wp-variant-select]');
      if (mainVariantSelect) mainVariantSelect.addEventListener('change', syncProduct);
    }

    phone.addEventListener('input', function () {
      error.hidden = true;
      phone.removeAttribute('aria-invalid');
    });
    form.addEventListener('submit', function (event) {
      var digits = phone.value.replace(/\D/g, '');
      if (digits.length < 10 || digits.length > 15) {
        event.preventDefault();
        error.hidden = false;
        phone.setAttribute('aria-invalid', 'true');
        phone.focus();
        return;
      }

      var requestedQuantity = cleanQuantity(quantity.value);
      if (order.checked && !requestedQuantity) {
        event.preventDefault();
        quantityError.hidden = false;
        quantity.setAttribute('aria-invalid', 'true');
        quantity.focus();
        return;
      }
      syncProduct();
      body.value = [
        'Request Tag: WPCCALLBACKREQUEST',
        ...(order.checked ? ['Request Tag: WPCORDERINTEREST'] : []),
        'Request Type: ' + (order.checked ? 'Interested in ordering' : 'General callback'),
        'Product URL: ' + productUrl,
        'Requested Quantity: ' + (order.checked ? requestedQuantity : 'Not requested'),
        'Phone: ' + phone.value.trim(),
        'Name: ' + (name.value.trim() || 'Not provided'),
        'Message: ' + (message.value.trim() || 'Not provided')
      ].join('\n');

      saveDraft();
      storageSet(activeKey, activeValue);
      storageSet(pendingKey, Date.now());
      // Native Shopify contact form and CAPTCHA handle the actual request.
    });

    var submittedAt = Number(storageGet(pendingKey)) || 0;
    var recentlySubmitted = submittedAt > 0 && Date.now() - submittedAt >= 0 && Date.now() - submittedAt < 15 * 60 * 1000;
    var activeForm = storageGet(activeKey);
    var ownsResponse = !activeForm || activeForm === activeValue;

    if (recentlySubmitted && ownsResponse) {
      storageRemove(pendingKey);
      storageRemove(activeKey);
      if (root.querySelector('[data-callback-server-success]')) {
        storageRemove(draftKey);
        tidyUrl();
        open(true);
      } else {
        restoreDraft();
        if (serverError) serverError.hidden = false;
        else fallbackError.hidden = false;
        open(false);
      }
    } else if (!recentlySubmitted) {
      storageRemove(draftKey);
    }

    document.addEventListener('shopify:section:unload', function (event) {
      if (event.target.contains(root)) {
        if (!overlay.hidden) close(false);
        if (overlay.parentNode === document.body) overlay.remove();
      }
    });
  } // end init(root)

  function scan() {
    document.querySelectorAll('.wpc-callback').forEach(init);
  }

  document.addEventListener('shopify:section:load', scan);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan, { once: true });
  } else {
    scan();
  }
})();